<template>
    <one-column-sidebar-left
        sub-menu-selector="adminpanel"
    >
        <div slot="buttonsRight">
            <Button
                    type="button"
                    class="mb-3 mt-5"
                    :deactivated="!enableSaving"
                    @click="save"
            >
                <icon v-if="enableSaving" type="save"/><icon v-else type="ban" /> {{ $t('SAVE') }}
            </Button>
        </div>
        <tabs slot="tabs"
              :classes="'col-12 col-md-2 col-lg-2 offset-md-1 backbutton'"
              :id="$route.params.id"
              :tab-selector="'rolebackbutton'"
              custom-tab-name="rolebackbutton"
              :first-inactive="true"
        />
        <tabs slot="tabs"
                :tab-selector="'roletab'"
                :disabled="true"
                :arrow-style="true"
                :id="'555'"
                :first-active="true"
        />
        <div slot="mainContent">
            <h1>{{ $t('createNewType', {type: $t('role')}) }}</h1>
            <input
                    type="text"
                    :class="['form-text', $v.name.$dirty && $v.name.$error ? 'form-group--error' : '']"
                    :id="'name'"
                    v-model="name"
                    :placeholder="$t('enternamehere')"
                    @input="delayTouch($v.name)"
            >

            <div class="form-error" v-if="$v.name.$dirty && !$v.name.required && $v.name.$error">{{ $t('errors.required') }}</div>
            <div class="form-error" v-if="$v.name.$dirty && !$v.name.alphaNum">{{ $t('errors.alphaNumOnly') }}</div>

            <div class="form-error" v-if="$v.name.$dirty && !$v.name.maxLength">{{ $t('errors.atMostCharacters', {num: 128}) }}</div>

            <div class="form-error" v-if="$v.name.$dirty && !$v.name.minLength">{{ $t('errors.atLeastCharacters', {num: 3}) }}</div>
            <div class="form-error" v-if="$v.name.$dirty && !$v.name.isUnique">{{ $t('errors.roleNameAlreadyExists') }}</div>

          <input
              type="text"
              :class="['form-text', $v.displayName.$dirty && $v.displayName.$error ? 'form-group--error' : '']"
              :id="'displayName'"
              v-model="displayName"
              :placeholder="$t('displayName')"
              @input="delayTouch($v.displayName)"
          >

          <div class="form-error" v-if="$v.displayName.$dirty && !$v.displayName.required && $v.displayName.$error">{{ $t('errors.required') }}</div>
          <div class="form-error" v-if="$v.displayName.$dirty && !$v.displayName.maxLength">{{ $t('errors.atMostCharacters', {num: 128}) }}</div>

          <div class="form-error" v-if="$v.displayName.$dirty && !$v.displayName.minLength">{{ $t('errors.atLeastCharacters', {num: 3}) }}</div>


          <div class="inline-edit-label">
                <b>{{ $t('description') }}</b>
            </div>
            <div>
                <textarea
                        :class="['form-text', $v.description.$dirty && $v.description.$error ? 'form-group--error' : '']"
                        :id="'description'"
                        v-model="description"
                        :placeholder="$t('enterdeschere')"
                        @input="delayTouch($v.description)"
                />
                <div class="form-error" v-if="$v.description.$dirty && !$v.description.maxLength">{{ $t('errors.atMostCharacters', {num: 128}) }}</div>
            </div>
        </div>
    </one-column-sidebar-left>
</template>

<script>
    import Button from "../components/forms/Button";
    import Tabs from "../components/navigation/Tabs";
    import OneColumnSidebarLeft from "../layouts/OneColumnSidebarLeft";
    import Icon from "../components/Icon";
    import { required, minLength, maxLength } from 'vuelidate/lib/validators';
    import {alphaNum} from '../customValidators';
    import VuelidateMixin from "@/components/mixins/VuelidateMixin.js";
    import {AdminData} from '@/enum';

    export default {
        name: "RoleAdd",
        components: {
            Button,
            Tabs,
            OneColumnSidebarLeft,
            Icon,
        },
        mixins: [VuelidateMixin],
        data() {
            return {
                id: '',
                enableSaving: false,
                name: '',
                description: '',
                displayName: '',
                AdminData: AdminData,
            };
        },
        watch: {
            '$v.$invalid': function() {
                this.enableSaving = !this.$v.$invalid;
                this.$emit('enableSaving', !this.$v.$invalid);
            },
        },
        validations: {
            name: {
                required,
                minLength: minLength(3),
                maxLength: maxLength(127),
                alphaNum,
                async isUnique(value) {
                    // standalone validator ideally should not assume a field is required
                    if (value === '') {
                        return true;
                    }
                    let bool = true;
                    await this.$store.dispatch('checkIfRoleNameExistsSpecial', {name: value}).then(data => {
                        bool = data.length === 0;
                    });
                    return bool;
                },
            },
            displayName: {
              required,
              minLength: minLength(3),
              maxLength: maxLength(127),
            },
            description: {
                maxLength: maxLength(1024),
            }
        },
        methods: {
            save: async function() {
                if(this.enableSaving) {
                    let args = {
                        name: this.name,
                        description: this.description,
                        displayName: this.displayName,
                        organizationId:  this.AdminData.vHubOrganizationId
                    };
                    this.$store.dispatch('createRole', args).then(data => {
                      this.$router.push('/admin/roles/'+data.id+'/general');
                    });
                }
            },
        },
    }
</script>